import { render, staticRenderFns } from "./PageArticle.vue?vue&type=template&id=18306bd2&scoped=true&"
import script from "./PageArticle.vue?vue&type=script&lang=js&"
export * from "./PageArticle.vue?vue&type=script&lang=js&"
import style0 from "./PageArticle.vue?vue&type=style&index=0&id=18306bd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18306bd2",
  null
  
)

export default component.exports